import styled from 'styled-components';
import { Colors } from '../colors';

interface IButtonProps {
  selected?: boolean;
}

export const PrimaryButton = styled.button<IButtonProps>`
  background-color: ${Colors.Red50};
  color: ${Colors.White};
  min-width: min(180px, 100%);
  margin: 0;
  padding: 0.65rem 2.4rem;

  border-radius: 8px;
  border: 0;

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  font-weight: 500;
  line-height: 140%;
  text-align: center;
  cursor: pointer;

  :hover {
    background-color: ${Colors.Red60};
  }
`;

export const TertiaryButton = styled.button<IButtonProps>`
  background-color: ${Colors.White};
  color: ${Colors.BlueGray4};
  min-width: min(12rem, 54vw);
  margin: 0;
  padding: 0.65rem 2.4rem;

  border-radius: 2rem;
  border: 2px solid ${Colors.BlueGray4};

  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  font-weight: 500;
  line-height: 140%;
  text-align: center;
  cursor: pointer;

  :disabled {
    cursor: not-allowed;
  }

  ${({ selected }) =>
    selected &&
    `
		background-color: ${Colors.DarkGrey} !important;
		border-color: ${Colors.DarkGrey};
		color: ${Colors.White};
	`};
`;
